import { type FC } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import { ReactComponent as ArrowLeftIcon } from "../../../../assets/images/keyboard-arrow-left-18.svg";
import { ReactComponent as ArrowRightIcon } from "../../../../assets/images/keyboard-arrow-right-18.svg";
import "./style.less";

export interface FooterButtonsProps {
  onBack?: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
  loading?: boolean;
  backLabel?: string;
  nextLabel?: string;
}

const FooterButtons: FC<FooterButtonsProps> = ({
  onBack,
  onNext,
  nextDisabled = false,
  loading = false,
  backLabel,
  nextLabel,
}) => {
  const { t } = useTranslation();

  return (
    <div className="rd-footer-buttons" data-testid="rd-footer-buttons">
      <Button
        type="text"
        className="rd-footer-buttons__back"
        icon={<ArrowLeftIcon aria-hidden />}
        disabled={loading}
        onClick={onBack}
      >
        {backLabel ??
          formatTranslation(t("newRatesAndDosage.footer.plotDesign"))}
      </Button>
      <Button
        className="rd-footer-buttons__next"
        disabled={nextDisabled}
        loading={loading}
        onClick={onNext}
        icon={<ArrowRightIcon aria-hidden />}
        iconPosition="end"
      >
        {nextLabel ?? formatTranslation(t("newRatesAndDosage.footer.summary"))}
      </Button>
    </div>
  );
};

export default FooterButtons;
